export const tablesToReset = [
    'monthly', 'autoDebit', 'rcboInvoice', 'creditLines', 'participantInterest',
    'actual', 'budget',
    'userListing','user',
    'specialFundHisotry',
    'loanSummary',
    'vendorInvoiceSummary',
    'blackBaudLog',
    'invoiceTaskSummary',
    'invoicesPaymentsTransactions',
    'blackBaudTransactionLog',
    "funds",
    "invoiceTasks",
];